import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'ColumnsOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-columns-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M4 6h2"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M4 10h5.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M4 14h5.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M4 18h5.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M14.5 6h5.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M14.5 10h5.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M18 14h2"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M14.5 18h3.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M3 3l18 18"
    }, null), _createTextVNode(" ")]);
  }
};